export default __webpack_public_path__ + "static/media/ic_wftm_24.e3a040e3.svg";